import React from 'react';
import { motion } from 'framer-motion';
import * as Lucide from 'lucide-react';
import { BasePageProps } from '../../Page/PageTypes';
import './PageCloseTab.css';

/**
 * PageCloseTab - Shows message to close this tab
 * 
 * Displayed when magic link was verified in a new tab and this original tab
 * couldn't be auto-closed (browser security restriction).
 */
export const PageCloseTab: React.FC<BasePageProps> = () => {
  return (
    <div className="page-close-tab-container">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="page-close-tab-card"
      >
        <Lucide.CheckCircle size={64} className="page-close-tab-icon" />
        <h2 className="page-close-tab-title">You're all set!</h2>
        <p className="page-close-tab-text">
          You've successfully logged in via your email link.
        </p>
        <p className="page-close-tab-subtext">
          You can now <strong>close this tab</strong> and continue playing in the other tab.
        </p>
      </motion.div>
    </div>
  );
};
